// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__qaD3W","title":"BackImages_title__12keb","images":"BackImages_images__Up_Ma"};